import { Icon } from '@/shared/ui/Icon';
import { ComingSoon } from '@/shared/ui/states/ComingSoon';

export const RoleManagementPage: React.FC = () => {
  return (
    <ComingSoon
      title="권한 관리"
      description="시스템 역할과 권한을 관리할 수 있습니다."
      icon={<Icon name="setting" />}
    />
  );
};
